import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "market-header-market-select__activator-market-data" }
const _hoisted_2 = { class: "market-header-market-select__market-name" }
const _hoisted_3 = { class: "market-header-market-select__activator-arrow" }
const _hoisted_4 = {
  key: 0,
  class: "market-header-market-select__content"
}
const _hoisted_5 = { class: "market-header-market-select__market-info" }
const _hoisted_6 = { class: "market-header-market-select__market-name" }

import { computed, onMounted, ref, type PropType } from 'vue';

import type { MarketModel } from '@exchange/libs/market/service/src';
import { MarketType } from '@exchange/libs/market/service/src/lib/market-model';

import MarketsContainer from '../MarketsContainer.vue';
import useMarketListFilters from '../useMarketListFilters';


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketHeaderMarketSelect',
  props: {
  isFutures: { type: Boolean, default: false },
  market: { type: Object as PropType<MarketModel>, required: false },
  marketsList: { type: Array as PropType<Array<MarketModel>>, required: false },
  showMarketList: { type: Boolean, default: false },
},
  emits: ["market-clicked"],
  setup(__props, { emit: __emit }) {

const props = __props;

const showML = ref(false);
const toggleSelect = () => {
  showML.value = !showML.value;
};

const emit = __emit;

const { applyMarketFilters } = useMarketListFilters();

const dropdownMaxHeight = ref(496);

const marketName = computed(() => props.market?.name);
const marketId = computed(() => props.market?.id);
const marketBaseCode = computed(() => props.market?.base.code);

const onSearchCallback = (search?: string) => applyMarketFilters({ search });

const onMarketSelect = (market: MarketModel) => {
  emit('market-clicked', market.id);
};
const onMarketListSelect = (mId: string) => {
  emit('market-clicked', mId);
  toggleSelect();
};

onMounted(() => {
  const appHeight = document.querySelector('#app')?.scrollHeight;

  if (appHeight) {
    dropdownMaxHeight.value = appHeight / 2;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_x_logo = _resolveComponent("x-logo")!
  const _component_ot_lozenge = _resolveComponent("ot-lozenge")!
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_x_list_item = _resolveComponent("x-list-item")!
  const _component_ot_select = _resolveComponent("ot-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.showMarketList)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['market-header-market-select market-header-market-select--list', { 'market-header-market-select--opened': showML.value }])
        }, [
          _createElementVNode("div", {
            class: "market-header-market-select__activator",
            onClick: toggleSelect
          }, [
            _createElementVNode("div", _hoisted_1, [
              (marketBaseCode.value)
                ? (_openBlock(), _createBlock(_component_x_logo, {
                    key: marketName.value,
                    class: "market-header-market-select__market-logo",
                    name: marketBaseCode.value,
                    type: "crypto"
                  }, null, 8, ["name"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_2, _toDisplayString(marketName.value), 1),
              (__props.market?.type === _unref(MarketType).PERP)
                ? (_openBlock(), _createBlock(_component_ot_lozenge, {
                    key: 1,
                    uppercase: false,
                    filled: false,
                    text: _ctx.$t('fundamentals.perpetual.short'),
                    class: "market-header-market-select__lozenge"
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_ot_icon, {
                name: "arrow-down",
                class: _normalizeClass({ 'market-header-market-select__activator-arrow--reversed': showML.value })
              }, null, 8, ["class"])
            ])
          ]),
          (showML.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (marketId.value)
                  ? (_openBlock(), _createBlock(MarketsContainer, {
                      key: 0,
                      variant: "dark-medium",
                      "market-id": marketId.value,
                      "with-logo": true,
                      "search-in-focus": true,
                      "is-futures": __props.isFutures,
                      onMarketClicked: onMarketListSelect
                    }, null, 8, ["market-id", "is-futures"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (!__props.showMarketList && __props.market && __props.marketsList)
      ? (_openBlock(), _createBlock(_component_ot_select, {
          key: 1,
          ref: "marketSelect",
          class: "market-header-market-select",
          label: "name",
          variant: "dark-borderless",
          "dropdown-max-height": `${dropdownMaxHeight.value}px`,
          "on-search-cb": onSearchCallback,
          options: __props.marketsList,
          searchable: true,
          value: __props.market,
          "onUpdate:value": onMarketSelect
        }, {
          "selected-option": _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (marketBaseCode.value)
                ? (_openBlock(), _createBlock(_component_x_logo, {
                    key: marketName.value,
                    class: "market-header-market-select__market-logo",
                    name: marketBaseCode.value,
                    type: "crypto"
                  }, null, 8, ["name"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, _toDisplayString(marketName.value), 1),
              (__props.isFutures)
                ? (_openBlock(), _createBlock(_component_ot_lozenge, {
                    key: 1,
                    uppercase: false,
                    filled: false,
                    text: _ctx.$t('fundamentals.perpetual.short'),
                    class: "market-header-market-select__lozenge"
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ])
          ]),
          option: _withCtx(({ name, id, base }) => [
            _createVNode(_component_x_list_item, {
              class: "market-header-market-select__option-item",
              active: __props.market.id === id,
              title: name,
              "left-icon-name": base.code,
              "left-icon-variant": "logo"
            }, _createSlots({ _: 2 }, [
              (__props.isFutures)
                ? {
                    name: "label-additional-content",
                    fn: _withCtx(() => [
                      _createVNode(_component_ot_lozenge, {
                        uppercase: false,
                        filled: false,
                        text: _ctx.$t('fundamentals.perpetual.short'),
                        class: "market-header-market-select__lozenge"
                      }, null, 8, ["text"])
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["active", "title", "left-icon-name"])
          ]),
          _: 1
        }, 8, ["dropdown-max-height", "options", "value"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})